<template>
    <div>
        <b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-up class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Document No." label-for="filter-name" size="sm" :model.sync="filter.name" />
                    <app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Document Type" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getInboxes"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
			<AppInbox :model="item" v-for="item in Inboxs" v-bind:key="item.id" />
			<div class="table-corner mb-3" v-if="false">
                <b-card no-body>
                    <b-card-header header-tag="header" role="tab" class="p-0" style="border-left: solid 4px #007bff">
                        <b-button v-b-toggle.inbox-1 class="filter" variant="white" block href="#">
                            <b-row>
                                <b-col cols="12" lg="1">
                                    <b-icon-file-bar-graph scale="4" style="margin-left: 34px; margin-top: 44px;" class="d-none d-lg-block"></b-icon-file-bar-graph>
                                </b-col>
                                <b-col cols="11" lg="10" style="margin-left: -20px;">
                                    <b-row class="mt-1 pl-3"><b-col class="text-dark">11-Nov-2021 11:23</b-col></b-row>
                                    <b-row class="mt-2 pl-3"><b-col><h4 class="font-weight-bold mb-0">SRF/2021/11/D109320</h4></b-col></b-row>
                                    <b-row class="mt-1 pl-3"><b-col class="text-secondary">Survey Request Form</b-col></b-row>
                                    <b-row class="mt-1 mb-2 pl-3"><b-col class="text-dark"><b-badge variant="primary">Waiting For Approval</b-badge></b-col></b-row>
                                </b-col>
                                <b-col cols="1" lg="1">
                                    <b-icon-chevron-up class="float-right chevron-right" style="margin-right:-25px;margin-top:50px;"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down" style="margin-right:-25px;margin-top:50px;"></b-icon-chevron-down>
                                </b-col>
                            </b-row>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="inbox-1" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col cols="12" lg="6">
                                    <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" label="Survey Main Customer" label-for="filter-survey-main-customer">
                                        <label class="p-value">HR Department</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-survey-theme" label-cols-sm="4" label-cols-lg="3" label="Survey Theme" label-for="filter-survey-theme">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-business-issue" label-cols-sm="4" label-cols-lg="3" label="Business Issue" label-for="filter-business-issue">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="5">
                                    <b-form-group id="fieldset-schedule-date-from" label-cols-sm="4" label-cols-lg="3" label="Schedule Date From" label-for="filter-schedule-date-from">
                                        <label class="p-value">15-Nov-2021</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-schedule-date-to" label-cols-sm="4" label-cols-lg="3" label="Schedule Date To" label-for="filter-schedule-date-to">
                                        <label class="p-value">20-Nov-2021</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="1">
                                    <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" label="" label-for="filter-survey-main-customer">
                                        <b-button size="sm" class="float-right float-bottom" :to="{path: '/inbox/srfapproval/20'}">Details</b-button>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
           <div class="table-corner mb-3" v-if="false">
                <b-card no-body>
                    <b-card-header header-tag="header" role="tab" class="p-0" style="border-left: solid 4px #007bff">
                        <b-button v-b-toggle.inbox-2 class="filter" variant="white" block href="#">
                            <b-row class="mt-2">
                                <b-col cols="10" lg="11">
                                    <b-row>
                                        <b-col cols="12" lg="1">
                                            <b-icon-file-check scale="1.5" class="d-none d-lg-block ml-lg-4"></b-icon-file-check>
                                        </b-col>
                                        <b-col cols="12" lg="2">
                                            <div class="text-dark pt-lg-1">13-Okt-2021 12:23</div>
                                        </b-col>
                                        <b-col cols="12" lg="3">
                                            <div>
                                                <h4 class="font-weight-bold mb-0 mb-lg-1">SEF/2021/10/D109320</h4>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" lg="2">
                                            <div class="text-secondary pt-lg-1">Survey Evaluation Form</div>
                                        </b-col>
                                        <b-col cols="12" lg="2">
                                            <b-badge variant="primary" class="mt-lg-2">Waiting For Approval</b-badge>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="2" lg="1">
                                    <span class="d-lg-none d-block">
                                        <b-icon-chevron-up style="margin-top:40px;margin-right:-10px" class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down style="margin-top:40px;margin-right:-10px" class="float-right chevron-down"></b-icon-chevron-down>
                                    </span>
                                    <span class="d-none d-lg-block">
                                        <b-icon-chevron-up class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
                                    </span>
                                </b-col>
                            </b-row>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="inbox-2" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col cols="12" lg="6">
                                    <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" label="Survey Main Customer" label-for="filter-survey-main-customer">
                                        <label class="p-value">HR Department</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-survey-theme" label-cols-sm="4" label-cols-lg="3" label="Survey Theme" label-for="filter-survey-theme">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-business-issue" label-cols-sm="4" label-cols-lg="3" label="Business Issue" label-for="filter-business-issue">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="5">
                                    <b-form-group id="fieldset-schedule-date-from" label-cols-sm="4" label-cols-lg="3" label="Schedule Date From" label-for="filter-schedule-date-from">
                                        <label class="p-value">15-Nov-2021</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-schedule-date-to" label-cols-sm="4" label-cols-lg="3" label="Schedule Date To" label-for="filter-schedule-date-to">
                                        <label class="p-value">20-Nov-2021</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="1">
                                    <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" label="" label-for="filter-survey-main-customer">
                                        <b-button size="sm" class="float-right float-bottom" >Details</b-button>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <div class="table-corner mb-3" v-if="false">
                <b-card no-body>
                    <b-card-header header-tag="header" role="tab" class="p-0" style="border-left: solid 4px #ffc107">
                        <b-button v-b-toggle.inbox-3 class="filter" variant="white" block href="#">
                            <b-row>
                                <b-col cols="12" lg="1">
                                    <b-icon-file-bar-graph class="d-none d-lg-block" scale="4" style="margin-left: 34px; margin-top: 44px;"></b-icon-file-bar-graph>
                                </b-col>
                                <b-col cols="11" lg="10" style="margin-left: -20px;">
                                    <b-row class="mt-1 pl-3"><b-col class="text-dark">07-Nov-2021 13:47</b-col></b-row>
                                    <b-row class="mt-2 pl-3"><b-col><h4 class="font-weight-bold mb-0">SRF/2021/08/SFWE2323</h4></b-col></b-row>
                                    <b-row class="mt-1 pl-3"><b-col class="text-secondary">Survey Request Form</b-col></b-row>
                                    <b-row class="mt-1 mb-2 pl-3"><b-col class="text-dark"><b-badge variant="warning">Need Revision</b-badge></b-col></b-row>
                                </b-col>
                                <b-col cols="1" lg="1">
                                    <b-icon-chevron-up class="float-right chevron-right" style="margin-right:-25px;margin-top:50px;"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down" style="margin-right:-25px;margin-top:50px;"></b-icon-chevron-down>
                                </b-col>
                            </b-row>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="inbox-3" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col cols="12" lg="6">
                                    <b-form-group id="fieldset-survey-main-customer" label-cols-sm="4" label-cols-lg="3" label="Survey Main Customer" label-for="filter-survey-main-customer">
                                        <label class="p-value">HR Department</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-survey-theme" label-cols-sm="4" label-cols-lg="3" label="Survey Theme" label-for="filter-survey-theme">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-business-issue" label-cols-sm="4" label-cols-lg="3" label="Business Issue" label-for="filter-business-issue">
                                        <label class="p-value">Campaign</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <b-form-group id="fieldset-schedule-date-from" label-cols-sm="4" label-cols-lg="3" label="Schedule Date From" label-for="filter-schedule-date-from">
                                        <label class="p-value">15-Nov-2021</label>
                                    </b-form-group>
                                    <b-form-group id="fieldset-schedule-date-to" label-cols-sm="4" label-cols-lg="3" label="Schedule Date To" label-for="filter-schedule-date-to">
                                        <label class="p-value">20-Nov-2021</label>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row style="margin-top: -30px">
                                <b-col>
                                    <b-button size="sm" class="float-right float-bottom">Details</b-button>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(InboxsPaging != null ? InboxsPaging.dataCount : 0)"
				:per-page="(InboxsPaging != null ? InboxsPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<RouterView />
    </div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    .p-value {
        padding-top: calc(0.375rem + 1px);
        padding-bottom: calc(0.375rem + 1px);
    }
    .btn.not-collapsed .chevron-down {
        display: inline;
    }

    .btn.not-collapsed .chevron-right {
        display: none;
    }

    .btn.collapsed .chevron-right {
        display: inline;
    }

    .btn.collapsed .chevron-down {
        display: none;
    }
</style>
<script>
import Inbox from '@/models/Inbox/Inbox';
import InboxList from '@/models/Inbox/InboxList';
import InboxFilter from '@/filters/Inbox/InboxFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import AppInbox from '@/components/AppInbox';
import AppItemInbox from '@/components/AppItemInbox';
import AppItemDetailInbox from '@/components/AppItemDetailInbox';

import PopupDataEditNotification from '@/components/PopupDataEditNotification';

export default {
	components : {Inbox, InboxList, InboxFilter, AppInputTextbox,PopupDownload,PopupPDF,PopupDataEditNotification,AppItemInbox,AppItemDetailInbox,AppInbox},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"name": {}, "class" : "th-name", "label" : "Name", key: 'name', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			Inboxs: [],
			InboxsPaging: {},
		}
	},
	methods : {
		getInboxes : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			Inbox.getInboxList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				console.log(result);
				if (result != null) {
					console.log(this.Inboxs);
					this.Inboxs = result
					this.InboxsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getInboxesWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			Inbox.getInboxList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.Inboxs = result
					this.InboxsPaging = result
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new InboxFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getInboxes();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Inbox.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Inbox.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			Inbox.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			Inbox.deleteData(this, id).then(result => {
				if (result)
				{
					this.getInboxes();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new InboxFilter();
	},
	mounted(){
		let breadcrumb =[
			"My Inbox"
		];
		this.getInboxes();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getInboxes();
			}
		},
		sortDesc: {
			handler: function() {
				this.getInboxes();
			}
		},
		currentPage: {
			handler: function() {
				this.getInboxes();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getInboxes();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Inbox.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "inboxindex") {
					this.getInboxesWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "schedule_plan_activity").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
